
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useChatOptional } from "@/context/ChatContext";

export const useSidebarLogic = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, signOut } = useAuth();
  
  // Use the optional hook that returns null when outside ChatProvider
  const chatContext = useChatOptional();
  const createNewSession = chatContext?.createNewSession ?? null;

  const isActivePath = (path: string) => {
    return location.pathname === path;
  };

  const handleLogout = async () => {
    try {
      await signOut();
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  const handleNewChat = async () => {
    if (!createNewSession) {
      navigate('/?newChat=true');
      return;
    }
    
    try {
      await createNewSession();
    } catch (error) {
      console.error('Sidebar: Failed to create new session:', error);
    }
  };

  return {
    user,
    isActivePath,
    handleLogout,
    handleNewChat
  };
};
